import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importReferralsContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "ReferralsContainer" */
                '@perpay-web/fintech/components/containers/ReferralsContainer'
            ),
    );
